const ACTIONS = {
  SELECT: 'select-option',
  DESELECT: 'deselect-option',
  REMOVE: 'remove-value',
  POP: 'pop-value',
  SET: 'set-value',
  CLEAR: 'clear',
  CREATE: 'create-option'
};

export { ACTIONS };
